import React, { lazy, Suspense } from 'react';
import { dashboardPagesMenu } from '../menu';

const LANDING = {
	PASTAS: lazy(() => import('../pages/presentation/pastas/PastasPage')),
	// eslint-disable-next-line import/no-unresolved, import/extensions
	DASHBOARD_PASTAS: lazy(() => import('../pages/presentation/dashboard-pastas/DashboardPastasPage')),
	USUARIOS: lazy(() => import('../pages/presentation/config/UsersConfigPage')),
	COMPETENCIA_INTERNA: lazy(() => import('../pages/presentation/config/CompetenciaInternaConfigPage')),
	FASE_PROCESSO: lazy(() => import('../pages/presentation/config/FaseProcessoConfigPage')),
	VARAS: lazy(() => import('../pages/presentation/config/VarasConfigPage')),
};

const RouteFallback = (
	<div className='d-flex align-items-center justify-content-center p-5'>
		<div className='spinner-border text-primary' role='status'>
			<span className='visually-hidden'>Carregando...</span>
		</div>
	</div>
);

const wrapLazy = (Component: React.LazyExoticComponent<React.ComponentType<object>>) => (
	<Suspense fallback={RouteFallback}>
		<Component />
	</Suspense>
);

const presentation = [
	{
		id: 'dashboard',
		path: dashboardPagesMenu.dashboard.path,
		element: wrapLazy(LANDING.PASTAS),
	},
	{
		id: 'dashboard-pastas',
		path: dashboardPagesMenu.dashboardPastas.path,
		element: wrapLazy(LANDING.DASHBOARD_PASTAS),
	},
	{
		id: 'usuarios',
		path: '/config/usuarios',
		element: wrapLazy(LANDING.USUARIOS),
	},
	{
		id: 'competencia-interna',
		path: '/config/competencia-interna',
		element: wrapLazy(LANDING.COMPETENCIA_INTERNA),
	},
	{
		id: 'fase-processo',
		path: '/config/fase-processo',
		element: wrapLazy(LANDING.FASE_PROCESSO),
	},
	{
		id: 'varas',
		path: '/config/varas',
		element: wrapLazy(LANDING.VARAS),
	},
];

const contents = [...presentation];

export default contents;
